export default {
  path: '/manage/leave',
  name: 'ManageLeave',
  component: () => import('../views/layouts/LeaveManage.layout.vue'),
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: 'check',
      name: 'ManageLeaveCheck',
      component: () =>
        import('../views/pages/Leave/Manage/LeaveCheck.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'cancel',
      name: 'ManageLeaveCheck',
      component: () =>
        import('../views/pages/Leave/Manage/LeaveCancel.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'pending/:guid',
      name: 'ManageLeavePending',
      component: () => import('../views/layouts/Blank.layout.vue'),
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: 'order/:leaveOrderId/timeline',
          name: 'ManageLeavePendingTimeline',
          component: () =>
            import('../views/pages/Leave/Manage/LeaveTimeline.page.vue'),
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: 'statusapprove',
      name: 'ManageLeaveCheckApprove',
      component: () =>
        import('../views/pages/Leave/Manage/LeaveApprove.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'emp',
      name: 'ManageLeaveEmp',
      component: () => import('../views/pages/Leave/Manage/LeaveEmp.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'rptleavemonth',
      name: 'ReportLeaveMonth',
      component: () =>
        import('../views/pages/Leave/Report/LeaveReportMonth.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'rptleavemonthall',
      name: 'ReportLeaveMonthAll',
      component: () =>
        import('../views/pages/Leave/Report/LeaveReportMonthAll.page.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: 'rptleavemonthtype',
      name: 'ReportLeaveMonthType',
      component: () =>
        import('../views/pages/Leave/Report/LeaveReportMonthType.page.vue'),
      meta: {
        requiresAuth: true
      }
    }
  ]
}
